import { Link } from 'react-router-dom'

// Custom Link component for ReactMarkdown
const CustomLink = ({ href, children, ...props }: any) => {
  // Check if it's an internal link (starts with /)
  if (href?.startsWith('/')) {
    return (
      <Link to={href} {...props}>
        {children}
      </Link>
    )
  }
  // External links use regular <a> tags
  return (
    <a href={href} {...props}>
      {children}
    </a>
  )
}

export default CustomLink
